<template lang="pug" src="../ModelDataTable/template.pug"/>

<script>
    //
    import ModelDataTable from '../ModelDataTable'
    //
    export default {
        name: 'table-field',
        extends: ModelDataTable,
        props: {
            /**
             * 
             */
            card: {
                type: Boolean,
                default: true,
            },
            
            /**
             * 
             */
            checkable: {
                type: Boolean,
                default: true,
            },

            /**
             * 
             */
            color: {
                type: String,
                default: 'primary',
            },
            
            /**
             * 
             */
            noActions: {
                type: Boolean,
                default: true,
            },

            /**
             * 
             */
            noDataText: {
                type: String,
                default: 'Sin items.',
            },

            /**
             * 
             */
            noExport: {
                type: Boolean,
                default: true,
            },

            /**
             * 
             */
            noFilter: {
                type: Boolean,
                default: true,
            },
            
            /**
             * 
             */
            noHelper: {
                type: Boolean,
                default: true,
            },

            /**
             * 
             */
            noPagination: {
                type: Boolean,
                default: true,
            },

            /**
             * 
             */
            noRefresh: {
                type: Boolean,
                default: true,
            },

            /**
             * 
             */
            noSearch: {
                type: Boolean,
                default: true,
            },

            selectableColumns: {
                type: Boolean,
                default: false,
            },
            
            /**
             * 
             */
            showNativePagination: {
                type: Boolean,
                default: true,
            },

            /**
             * 
             */
            toolbarColor: {
                type: String,
                default: 'primary',
            },
            
            /**
             * 
             */
            toolbarDark: {
                type: Boolean,
                default: true,
            },

            /**
             * 
             */
            toolbarDense: {
                type: Boolean,
                default: true,
            },

            /**
             *
             */
            value: {
                type: Array,
                default: () => [],
            },
        },
    }
</script>

<style>
    .data-table-model.v-card {
        margin-bottom: 28px;
    }
</style>